import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/context/AuthContext";

export default function AcceptInstructorInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/accept-instructor-invite", {
        token,
        password,
        display_name: displayName || undefined,
      });
      setDone(true);
      setPassword("");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card max-w-xl space-y-6" data-testid="accept-instructor-invite-page">
      <h1 className="text-base md:text-lg font-semibold">Activate instructor account</h1>
      {done ? (
        <div className="space-y-4">
          <p data-testid="accept-invite-success">Account created. You can now log in as an instructor.</p>
          <Link to="/login" className="btn-primary inline-block" data-testid="accept-invite-login-link">
            Log in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {!token && (
            <p role="alert" className="text-destructive" data-testid="accept-invite-no-token">
              No invitation token provided.
            </p>
          )}
          <div className="space-y-1">
            <label htmlFor="accept-display-name" className="font-medium">
              Display name (optional)
            </label>
            <input
              id="accept-display-name"
              data-testid="accept-display-name"
              className="input"
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
            />
          </div>
          <div className="space-y-1">
            <label htmlFor="accept-password" className="font-medium">
              Password (minimum 12 characters)
            </label>
            <input
              id="accept-password"
              data-testid="accept-password"
              className="input"
              type="password"
              required
              minLength={12}
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {error && (
            <p role="alert" className="text-destructive" data-testid="accept-invite-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            className="btn-primary"
            disabled={busy || !token}
            data-testid="accept-invite-submit"
          >
            {busy ? "Saving…" : "Activate account"}
          </button>
        </form>
      )}
    </div>
  );
}
